(() => {
  const colors = {
    black: '#111111', schwarz: '#111111', white: '#ffffff', weiss: '#ffffff', weiß: '#ffffff',
    navy: '#14213d', marine: '#14213d', royal: '#2455a4', blue: '#2867b2', blau: '#2867b2',
    sky: '#79bfe7', turquoise: '#27aeb5', türkis: '#27aeb5', red: '#c92f39', rot: '#c92f39',
    burgundy: '#6f1d2c', bordeaux: '#6f1d2c', pink: '#e8799b', rosa: '#e8799b',
    orange: '#e56824', yellow: '#e8c62d', gelb: '#e8c62d', green: '#348052', grün: '#348052',
    olive: '#727443', khaki: '#93845e', brown: '#76513a', braun: '#76513a', beige: '#d7c5a5',
    natural: '#e8dfca', sand: '#d5bd98', grey: '#818181', gray: '#818181', grau: '#818181',
    silver: '#b7bbc0', silber: '#b7bbc0', purple: '#704b8f', lila: '#704b8f', violet: '#704b8f'
  };

  const colorFor = (option) => {
    const configured = option.dataset.optionSwatchValue;
    if (configured) return configured;
    const name = option.value.toLowerCase().trim();
    const productColors = window.__aloeSwatches || {};
    if (productColors[name]) return productColors[name];
    if (colors[name]) return colors[name];
    const key = Object.keys(colors).find((entry) => name.includes(entry));
    return key ? colors[key] : '#d7d4cf';
  };

  const swatch = (color) => {
    const item = document.createElement('span');
    item.className = 'aloe-color-dropdown__swatch';
    item.style.setProperty('--aloe-option-color', color);
    return item;
  };

  const enhance = (select) => {
    if (select.dataset.aloeColorReady === 'true') return;
    const input = select.closest('.product-form__input--dropdown');
    const label = input && input.querySelector('.form__label');
    const name = `${select.name} ${label ? label.textContent : ''}`.toLowerCase();
    if (!name.includes('farbe') && !name.includes('color') && !name.includes('colour')) return;

    select.dataset.aloeColorReady = 'true';
    const selectWrap = select.closest('.select');
    if (!selectWrap) return;
    selectWrap.classList.add('aloe-color-dropdown');
    select.classList.add('aloe-color-dropdown__native');

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'aloe-color-dropdown__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    const menu = document.createElement('div');
    menu.className = 'aloe-color-dropdown__menu';
    menu.setAttribute('role', 'listbox');

    const overview = document.createElement('div');
    overview.className = 'aloe-color-overview';
    overview.setAttribute('role', 'group');
    overview.setAttribute('aria-label', 'Verfügbare Farben');

    const sync = () => {
      const selected = select.options[select.selectedIndex] || select.options[0];
      if (!selected) return;
      trigger.replaceChildren(swatch(colorFor(selected)), document.createTextNode(selected.textContent.trim()));
      menu.querySelectorAll('.aloe-color-dropdown__option').forEach((button) => {
        button.setAttribute('aria-selected', button.dataset.value === select.value ? 'true' : 'false');
      });
      overview.querySelectorAll('.aloe-color-overview__option').forEach((button) => {
        const active = button.dataset.value === select.value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    Array.from(select.options).forEach((option) => {
      const choose = () => {
        if (option.disabled) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        selectWrap.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        sync();
      };

      const colorButton = document.createElement('button');
      colorButton.type = 'button';
      colorButton.className = 'aloe-color-overview__option';
      colorButton.dataset.value = option.value;
      colorButton.style.setProperty('--aloe-option-color', colorFor(option));
      colorButton.setAttribute('aria-label', option.textContent.trim());
      colorButton.setAttribute('title', option.textContent.trim());
      colorButton.disabled = option.disabled;
      colorButton.addEventListener('click', choose);
      overview.appendChild(colorButton);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'aloe-color-dropdown__option';
      button.dataset.value = option.value;
      button.setAttribute('role', 'option');
      button.append(swatch(colorFor(option)), document.createTextNode(option.textContent.trim()));
      button.addEventListener('click', choose);
      menu.appendChild(button);
    });

    trigger.addEventListener('click', () => {
      const open = !selectWrap.classList.contains('is-open');
      document.querySelectorAll('.aloe-color-dropdown.is-open').forEach((item) => item.classList.remove('is-open'));
      selectWrap.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    select.addEventListener('change', sync);
    input.insertBefore(overview, selectWrap);
    selectWrap.prepend(trigger);
    selectWrap.append(menu);
    sync();
  };

  const init = (root = document) => root.querySelectorAll('select[name^="options["]').forEach(enhance);
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.aloe-color-dropdown.is-open').forEach((item) => {
      if (!item.contains(event.target)) {
        item.classList.remove('is-open');
        item.querySelector('.aloe-color-dropdown__trigger')?.setAttribute('aria-expanded', 'false');
      }
    });
  });
  new MutationObserver(() => init()).observe(document.documentElement, { childList: true, subtree: true });
})();
